module.exports = __webpack_public_path__ + "static/img/rank-bg.030b5a76.png";